export default __webpack_public_path__ + "static/media/cha_healer_nightingale.d9a419da.png";